var map = {
	"./01.jpg": 1007,
	"./02.jpg": 8016,
	"./03.jpg": 3581,
	"./04.jpg": 6710,
	"./05.jpg": 8323,
	"./06.jpg": 8276,
	"./07.jpg": 6321,
	"./08.jpg": 8970,
	"./09.jpg": 135,
	"./10.jpg": 8662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1542;